if (!customElements.get('feature-gallery-sj')) {
  class FeatureGallerySJ extends HTMLElement {
    connectedCallback() {
      if (this.desktop) return;

      this.desktop = window.matchMedia('(min-width: 769px)');
      this.desktopChangeBound = () => {
        this.syncNavigation();
        this.syncMainVideos();
      };
      this.desktop.addEventListener('change', this.desktopChangeBound);
      this.initMainVideos();

      this.viewport = this.querySelector('[data-feature-gallery-viewport]');
      if (!this.viewport || this.swiper) return;

      this.navigation = this.querySelector('[data-feature-gallery-navigation]');
      this.previousButton = this.querySelector('[data-feature-gallery-prev]');
      this.nextButton = this.querySelector('[data-feature-gallery-next]');
      this.initBound = this.initSwiper.bind(this);
      this.blockSelectBound = this.handleBlockSelect.bind(this);

      this.addEventListener('shopify:block:select', this.blockSelectBound);

      if (window.Swiper) this.initSwiper();
      else window.addEventListener('load', this.initBound, { once: true });
    }

    disconnectedCallback() {
      this.removeEventListener('shopify:block:select', this.blockSelectBound);
      this.desktop?.removeEventListener('change', this.desktopChangeBound);
      document.removeEventListener('visibilitychange', this.videoVisibilityBound);
      this.videoObserver?.disconnect();
      this.videos?.forEach(video => video.pause());
      window.removeEventListener('load', this.initBound);
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.desktop = null;
    }

    initMainVideos() {
      this.videos = [...this.querySelectorAll('.feature-gallery-sj__main-video')];
      if (!this.videos.length) return;

      // 进入视口时才加载播放，切换断点或离开页面时暂停隐藏的视频。
      this.isMediaVisible = false;
      this.videoVisibilityBound = this.syncMainVideos.bind(this);
      document.addEventListener('visibilitychange', this.videoVisibilityBound);
      this.videoObserver = new IntersectionObserver(([entry]) => {
        this.isMediaVisible = entry.isIntersecting;
        this.syncMainVideos();
      });
      this.videoObserver.observe(this.querySelector('.feature-gallery-sj__media'));
    }

    syncMainVideos() {
      const visibleClass = this.desktop?.matches ? 'feature-gallery-sj__main-video--mobile' : 'feature-gallery-sj__main-video--desktop';
      const activeVideo = this.videos?.find(video => !video.classList.contains(visibleClass));

      this.videos?.forEach(video => {
        if (video !== activeVideo || !this.isConnected || !this.isMediaVisible || document.hidden) {
          video.pause();
        } else if (video.paused) {
          video.muted = true;
          video.play().catch(() => {});
        }
      });
    }

    initSwiper() {
      if (!this.isConnected || this.swiper || !window.Swiper) return;

      // 卡片宽度由 CSS 控制，Swiper 负责鼠标拖拽、横向滚轮和按钮翻页。
      this.swiper = new window.Swiper(this.viewport, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        watchOverflow: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        freeMode: { enabled: true },
        mousewheel: { forceToAxis: true, releaseOnEdges: true },
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { enabled: true },
        navigation: {
          prevEl: this.previousButton,
          nextEl: this.nextButton,
        },
        breakpoints: {
          769: { spaceBetween: 16 },
        },
        on: {
          init: swiper => this.syncNavigation(swiper),
          resize: swiper => this.syncNavigation(swiper),
          update: swiper => this.syncNavigation(swiper),
          slideChange: swiper => this.syncNavigation(swiper),
          reachBeginning: swiper => this.syncNavigation(swiper),
          reachEnd: swiper => this.syncNavigation(swiper),
          fromEdge: swiper => this.syncNavigation(swiper),
          lock: swiper => this.syncNavigation(swiper),
          unlock: swiper => this.syncNavigation(swiper),
        },
      });

      this.syncNavigation();
    }

    syncNavigation(swiper = this.swiper) {
      if (!swiper) return;

      const hasOverflow = swiper.snapGrid.length > 1 && !swiper.isLocked;
      this.viewport.classList.toggle('feature-gallery-sj__viewport--overflow', hasOverflow);
      if (!this.navigation) return;
      this.navigation.hidden = !this.desktop.matches || !hasOverflow;
      this.previousButton.disabled = swiper.isBeginning;
      this.nextButton.disabled = swiper.isEnd;
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.swiper) return;

      const card = event.target.closest('[data-feature-gallery-card]');
      if (!card || !this.contains(card)) return;

      const index = Number.parseInt(card.dataset.cardIndex, 10);
      if (!Number.isNaN(index)) this.swiper.slideTo(index, 0);
    }
  }

  customElements.define('feature-gallery-sj', FeatureGallerySJ);
}
